
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue'
import { Popup, Icon } from 'vant'

export default defineComponent({
  name: 'Video',
  components: {
    Popup,
    Icon
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    on: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const playerRef = ref<null | HTMLVideoElement>(null)
    const showVideo = ref(false)
    const userAgent = window.navigator.userAgent
    const isSafari = /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)

    if (isSafari) {
      let isEnter = false
      const observer = new IntersectionObserver(
        intersections => {
          const intersection = intersections?.[0]
          if (playerRef.value && intersection) {
            if (intersection.isIntersecting) {
              isEnter = true
            } else if (isEnter) {
              isEnter = false
              setTimeout(() => {
                playerRef.value && playerRef.value.pause()
              })
            }
          }
        },
        { threshold: 1 }
      )
      onMounted(() => {
        if (playerRef.value) {
          observer.observe(playerRef.value)
        }
      })
      onUnmounted(() => {
        if (playerRef.value) {
          observer.unobserve(playerRef.value)
        }
      })
    } else {
      watch(showVideo, v => {
        if (playerRef.value) {
          v ? playerRef.value.play() : playerRef.value.pause()
        }
      })
    }

    return {
      isSafari,
      showVideo,
      playerRef,
      handlerOn(type: string) {
        props.on?.[type]?.()
      },
      getPlayer() {
        return playerRef
      }
    }
  }
})
